var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H2C1.44772 19 1 18.5523 1 18V2C1 1.44772 1.44772 1 2 1H18C18.5523 1 19 1.44772 19 2V18C19 18.5523 18.5523 19 18 19ZM3 3V17H17V3H3ZM12 15H9V11H8V9H11V13H12V15ZM11 7H9V5H11V7Z",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquare);
export default __webpack_public_path__ + "static/media/info_square.7fd862bb00d869631c326afb5e08db9b.svg";
export { ForwardRef as ReactComponent };